<!-- 2022 世界杯 新闻专题-->
<template>
<div class="schedule">
    <TopBanner :banner="banner" />
    <div class="container">
        <div class="table">
            <div class="tab">
                <div class="item" :class="{active:type == 1}" @click="typeChange(1)">赛程预告</div>
                <div class="item" :class="{active:type == 2}" @click="typeChange(2)">已结束</div>
            </div>
            <div class="list">
                <div class="item" v-for="item in list" :key="item.day">
                    <div class="tab-hd cont-row">
                        <div class="flex-cont">{{item.day}} {{weekList[item.week]}}</div>
                        <div class="cont">{{item.list.length}}场比赛</div>
                    </div>
                    <template v-for="(itm,index) in item.list">
                        <div class="tab-item cont-row" :key="index" :class="{border:index != item.list.length-1}">
                            <div class="time">{{itm.gameStartTime|timeFormat('h:i')}}</div>
                            <div class="flex-cont">
                                <div class="cont-row team">
                                    <div class="ico"><img :src="itm.team1.imageUrl" alt=""></div>
                                    <div class="flex-cont name">{{itm.team1.name}}</div>
                                    <div class="score" v-if="itm.status==0">-</div>
                                    <div class="score" v-if="itm.status==2">{{itm.team1.score}}</div>
                                </div>
                                <div class="cont-row team">
                                    <div class="ico"><img :src="itm.team2.imageUrl" alt=""></div>
                                    <div class="flex-cont name">{{itm.team2.name}}</div>
                                    <div class="score" v-if="itm.status==0">-</div>
                                    <div class="score" v-if="itm.status==2">{{itm.team2.score}}</div>
                                </div>
                            </div>
                        
                            <div class="result" v-if="itm.status == 0">未开始</div>
                            <div class="result" v-else-if="itm.status == 1" >进行中</div>
                            <div class="result" v-else-if="itm.status == 2">已结束</div>
                        </div>
                    </template>
                
                </div>
            </div>
        </div>
    </div>
    <CssFooter />
</div>
</template>
<script>
import TopBanner from '@/components/widgets/top-banner.vue'
import CssFooter from '@/components/css-footer.vue'
export default {
    name:'FifaSchedule2022',
    components:{TopBanner,CssFooter},
    data(){
        return  {
            banner:{
                pcBanner:'https://media5.imgyb.xyz/media/v1/image/d0e0535d58ee0c8d8979818c63dab918.png',
                pcBannerBg:'https://media7.imgyb.xyz/media/v1/image/bbd0fbee3c3032fd045960724cb60f05.png',
                mBanner:'https://media2.imgyb.xyz/media/v1/image/fd4b21302417fd8c84fa88b2d7a919f2.png',
            },
            weekList:['星期日','星期一','星期二','星期三','星期四','星期五','星期六'],
            originList:[],
            list:[
                /* {
                    day:'12-02',
                    week:'星期一',
                    list:[]
                } */
            ],
            type:1,
        }
    },
    created(){
        this.getList()
    },
    methods: {
        fillZone(num){
            if( num < 10 ){
                return '0'+num;
            }else{
                return num;
            }
        },
        async getList(){
            let result = await this.$axios.post('/worldcup2022/admin/result/game/list2',{"statuses": [0,1,2],});
            //console.log(result);
            if( result.code != 0 ){
                this.$warning(result.msg)
                return false;
            }
            this.originList = result.data.games;
            this.renderList();
            /* let orderResult = result.data.games.sort(function(a,b){
                let start = new Date(a.gameStartTime).getTime();

                let end = new Date(b.gameStartTime).getTime();
                return start >end;
            }) */
           
           /*  for(var i=0; i<orderResult.length; i++){
                let startTime = new Date(orderResult[i].gameStartTime);
                let month = startTime.getMonth()+1;
                let day = startTime.getDate();
                let key =this.fillZone(month)+'-'+ this.fillZone(day);
                console.log(key);
                if(cacheList.length == 0 ){
                    cacheList.push({
                        day:key,
                        week:startTime.getDay(),
                        list:[],
                    })
                }else{
                    if( cacheList[cacheList.length-1].day != key){
                        cacheList.push({
                            day:key,
                            week:startTime.getDay(),
                            list:[],
                        })
                    }
                }
                cacheList[cacheList.length-1].list.push(orderResult[i])
            }
            console.log('orderResult ====>',orderResult)
            console.log(cacheList)
            this.list = cacheList; */
        },
        renderList(){
            let cacheList = [];
            let orderResult = [];
            if( this.type == 1 ){
                orderResult = this.originList.filter((el)=>{
                   return [0,1].includes(el.status)
                })
            }else {
                orderResult = this.originList.filter((el)=>{
                    return  el.status == 2
                });
            }
            orderResult = orderResult.sort(function(a,b){
                let start = new Date(a.gameStartTime).getTime();

                let end = new Date(b.gameStartTime).getTime();
                return start >end;
            })
            for(var i=0; i<orderResult.length; i++){
                let startTime = new Date(orderResult[i].gameStartTime);
                let month = startTime.getMonth()+1;
                let day = startTime.getDate();
                let key =this.fillZone(month)+'-'+ this.fillZone(day);
                console.log(key);
                if(cacheList.length == 0 ){
                    cacheList.push({
                        day:key,
                        week:startTime.getDay(),
                        list:[],
                    })
                }else{
                    if( cacheList[cacheList.length-1].day != key){
                        cacheList.push({
                            day:key,
                            week:startTime.getDay(),
                            list:[],
                        })
                    }
                }
                cacheList[cacheList.length-1].list.push(orderResult[i])
            }
            this.list = cacheList;
        },
        typeChange(index){
            if( this.type == index) return false;
            this.type = index;
            this.renderList();
        }
    }

}
</script>
<style lang="less" scoped>
.schedule{background: #f8f8f8;}
.table{
    width:720px; margin: 30px auto 50px; background: #fff; padding: 30px 35px; border-radius: 10px;  box-sizing: border-box;
    .tab{
        display: flex; align-items: center; font-size: 16px; color: #999; margin-bottom: 15px; padding-top: 5px;
        .item{margin-right: 10px; user-select: none; cursor: pointer;
            &.active{color: #111; font-weight: bold;}
        }
    }
    .tab-hd {
        font-size: 12px; line-height: 30px; color: #111; background: #f5f5f5; padding: 0 11px 0 25px;
        .cont{color: #999;}
        
    }
    .tab-item{
        margin: 0 10px; padding: 10px 0;
        &.border{border-bottom: 1px solid #eee;}
        .ico{
            margin-right: 10px;border:1px solid #eee;
            img{display: block; width: 24px; height: 16px; object-fit: cover;}
        }
        .name{font-size: 14px; line-height: 20px; color: #111; }
        .team{
            padding: 5px 0;
        }
        .time{margin-right: 50px;margin-left: 15px; font-size: 16px; font-weight: bold;}
        .result{margin-left: 50px; font-size: 14px;}
    }
}
@media screen and (max-width:768px){
    .container{
        padding: 0 15px;
    }
    .table{width:100%; padding: 10px 15px; margin:10px auto 10px;}
}

</style>